<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="feedbackFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <feedback-filter-form-item
        :form="form"
        :field="field"
        :options="{
          statusList: feedbackStatus,
          types: feedbackTypes
        }"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { feedbackStatus, feedbackTypes } from '@/utils/dictionary';
import CommonFilterForm from '@/components/CommonFilterForm';
import FeedbackFilterFormItem from './FeedbackFilterFormItem.vue';

export default {
  name: 'FeedbackFilterForm',
  components: {
    CommonFilterForm,
    FeedbackFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      feedbackStatus,
      feedbackTypes,
      // 所有可用的筛选项配置
      allFields: [
        { key: 'title', label: '标题', span: 6 },
        { key: 'status', label: '状态', span: 6 },
        { key: 'user_id', label: '创建人', span: 6 },
        { key: 'type', label: '反馈类型', span: 6 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['title', 'status', 'type'],
      // 默认更多筛选字段
      defaultMoreFields: ['user_id']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      const defaultForm = {
        title: '',
        status: undefined,
        user_id: null,
        type: undefined
      };
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    }
  }
};
</script>

<style lang="less" scoped>
.feedback-filter-form {
  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }
}
</style>
